// How a quiz or assessment score reads under Audience Requirements (DA-5056 R5).
//
// In a program with audience groups, a learner who only reads every lesson (a
// Read Only group) is assessed on nothing there. The backend sends their score
// as null, not 0 (mcqScore, MCQScore, quizScore, runningScore), leaves it out
// of every average, and gives their gamification Knowledge Retention and
// Knowledge Mastery value "-", pct null and medal null. The front end shows a
// dash there: never 0%, never a medal. Programs without audience groups never
// send null, so nothing here changes how they read.

/** What a score reads when nothing it measures is required of the learner. */
export const NOT_REQUIRED = '-';

/**
 * The rounded average of the scores that are required, as the backend
 * averages them: nulls are left out. Null when there are scores and every one
 * is null; `empty` when there are none at all. With no null among them, the
 * plain rounded average.
 */
export function averageOfRequired(scores: ReadonlyArray<number | null>, empty = 0): number | null {
  const required = scores.filter((s): s is number => s !== null);
  if (required.length === 0) return scores.length > 0 ? null : empty;
  return Math.round(required.reduce((sum, s) => sum + s, 0) / required.length);
}

/** A score as `format` writes it ("72%" by default), or the dash when nothing is required (null). */
export const scoreOrDash = (score: number | null, format: (n: number) => string = (n) => `${n}%`): string =>
  score === null ? NOT_REQUIRED : format(score);
